import http from '@/utils/http';

const URL_BASE = '/perfil';

export default {
    buscaPerfilpessoa() {
        return http.get({
            url: URL_BASE + `/pessoa`,
            lockScreen: false
        });
    }
};
